/* ============================================================================
   access-block-copy.js - blocked account / IP messages shown after sign-out
   ============================================================================ */

import { KOFI_URL, INSTAGRAM_URL } from "./sample-data.js?v=20261007m";

export const ACCESS_BLOCK_STORAGE_KEY = "ccj_access_block";

export function accessBlockCopy(reason) {
  const kind = reason === "ip" ? "ip" : "account";
  if (kind === "ip") {
    return {
      reason: "ip",
      title: "This connection can't enter the jar",
      body:
        "For safety reasons, CookieCodeJar isn't available from this network (IP). " +
        "If that doesn't sound right, message me and I'll take a look.",
    };
  }
  return {
    reason: "account",
    title: "This account can't enter the jar",
    body:
      "For safety reasons, this CookieCodeJar account has been blocked from signing in. " +
      "If that doesn't sound right, message me and I'll take a look.",
  };
}

export function accessBlockAppealHtml() {
  const ig = INSTAGRAM_URL;
  const kofi = KOFI_URL;
  return (
    `Message me on <a href="${ig}" target="_blank" rel="noopener noreferrer">Instagram</a>` +
    ` or <a href="${kofi}" target="_blank" rel="noopener noreferrer">Ko-fi</a>.`
  );
}

export function rememberAccessBlock(reason) {
  const copy = accessBlockCopy(reason);
  try {
    sessionStorage.setItem(ACCESS_BLOCK_STORAGE_KEY, JSON.stringify(copy));
  } catch (_) {}
  return copy;
}

export function consumeAccessBlock() {
  let fromStorage = null;
  try {
    const raw = sessionStorage.getItem(ACCESS_BLOCK_STORAGE_KEY);
    if (raw) {
      sessionStorage.removeItem(ACCESS_BLOCK_STORAGE_KEY);
      fromStorage = JSON.parse(raw);
    }
  } catch (_) {}

  const params = new URLSearchParams(window.location.search || "");
  const q = params.get("blocked");
  if (q === "ip" || q === "account") {
    params.delete("blocked");
    const next = `${window.location.pathname}${params.toString() ? `?${params}` : ""}${window.location.hash || ""}`;
    window.history.replaceState({}, "", next);
    return accessBlockCopy(q);
  }

  if (fromStorage?.title && fromStorage?.body) return fromStorage;
  return null;
}
